export const oddsHubMarkets = [
    { id: 'all', name: 'All Markets' },
    { id: 'asian_handicap', name: 'Asian Handicap' },
    { id: 'goal_line', name: 'Goal Line' },
    { id: 'burmese_handicap', name: 'Burmese Handicap' }
];

export const oddsHubMatches = [
    {
        id: 'premier-league',
        league: 'Premier League',
        kickoff: '2025-12-29 02:30 PM',
        reference: [
            {
                id: 'premier-bet365',
                bookmaker: 'Bet365',
                matchup: 'Arsenal vs Chelsea',
                asian_handicap: [

                ],
                goal_line: [

                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            },
            {
                id: 'premier-william-hill',
                bookmaker: 'William Hill',
                matchup: 'Arsenal vs Chelsea',
                asian_handicap: [

                ],
                goal_line: [

                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            },
        ],
        base: [
            {
                id: 'premier-william-hill',
                bookmaker: 'William Hill',
                matchup: 'Arsenal vs Chelsea',
                asian_handicap: [
                    {
                        odds: "2.025",
                        header: "1",
                        handicap: "+0.5,+1.0"
                    },
                    {
                        odds: "1.775",
                        header: "2",
                        handicap: "-0.5,-1.0"
                    }
                ],
                goal_line: [
                    {
                        odds: "1.825",
                        header: "Over",
                        name: "2.5, 3.0"
                    },
                    {
                        odds: "1.975",
                        header: "Under",
                        name: "2.5, 3.0"
                    }
                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            }
        ]
    },
    {
        id: 'premier-league',
        league: 'Premier League',
        kickoff: '2025-12-29 02:30 PM',
        reference: [
            {
                id: 'premier-bet365',
                bookmaker: 'Bet365',
                matchup: 'Man U vs Spurs',
                asian_handicap: [

                ],
                goal_line: [

                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            },
            {
                id: 'premier-william-hill',
                bookmaker: 'William Hill',
                matchup: 'Man U vs Spurs',
                asian_handicap: [

                ],
                goal_line: [

                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            },
        ],
        base: [
            {
                id: 'premier-william-hill',
                bookmaker: 'William Hill',
                matchup: 'Man U vs Spurs',
                asian_handicap: [
                    {
                        odds: "2.025",
                        header: "1",
                        handicap: "+0.5,+1.0"
                    },
                    {
                        odds: "1.775",
                        header: "2",
                        handicap: "-0.5,-1.0"
                    }
                ],
                goal_line: [
                    {
                        odds: "1.825",
                        header: "Over",
                        name: "2.5, 3.0"
                    },
                    {
                        odds: "1.975",
                        header: "Under",
                        name: "2.5, 3.0"
                    }
                ],
                burmese_handicap: { body: "1+45", goal: "4+90" }
            }
        ]
    },
];

